const accountStatuses = {
	ACTIVE: 'active',
	SUSPENDED: 'suspended',
	TERMINATED: 'terminated',
	PENDING_NEW: 'pending-new',
};

export default accountStatuses;
